import React from 'react'
import Layout from '../components/Layout'
import Hero from '../components/Hero'
import Posts from '../components/Posts'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'

// updated

const CategoryTemplate = props => {
  const {
    data: {
      categories: { nodes: posts },
    },
  } = props
  const {
    pageContext: { category },
  } = props

  const APP_NAME = 'Devsrcblog'

  return (
    <React.Fragment>
      <Helmet>
        <title>
          {category} category | {APP_NAME}
        </title>
        <meta
          name="description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <link rel="canonical" href="http://localhost:8000" />
        <meta
          property="og:title"
          content={`Latest web developoment tutorials | ${APP_NAME}`}
        />
        <meta
          property="og:description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <meta property="og:type" content="webiste" />
        <meta property="og:url" content="http://localhost:8000" />
        <meta property="og:site_name" content={`${APP_NAME}`} />

        <meta
          property="og:image"
          content={`http://localhost:8000/static/mainImg.png`}
        />
        <meta
          property="og:image:secure_url"
          content={`http://localhost:8000/static/mainImg.png`}
        />
        <meta property="og:image:type" content="image/jpg" />
      </Helmet>

      <Layout>
        <Hero showPerson />
        <Posts posts={posts} title={`category / ${category}`} />
      </Layout>
    </React.Fragment>
  )
}

export const query = graphql`
  query GetCategories($category: String) {
    categories: allMdx(
      sort: { fields: frontmatter___date, order: DESC }
      filter: { frontmatter: { category: { eq: $category } } }
    ) {
      nodes {
        excerpt
        frontmatter {
          title
          author
          category
          date(formatString: "MMMM, Do YYYY")
          slug
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        id
      }
    }
  }
`

export default CategoryTemplate
